// Actions
export var SET_INPUT = 'RI_SET_INPUT';